// src/components/faq/PerceptualResearchInfrastructureFAQ.jsx

const perceptualResearchInfrastructureFaqItems = [
  {
    question: 'What is Perceptual Research Infrastructure?',
    answer:
      'Perceptual Research Infrastructure is the All-Voiced service line for designing, configuring, coordinating, and operating the perceptual layer of clinical and research studies that require structured human evaluation of voice.',
  },
  {
    question: 'Is this only for perceptual or psychophysical research?',
    answer:
      'No. Some projects focus directly on perception or psychophysics, while others use perceptual evaluation as one measurement layer within a broader clinical, methodological, educational, biomarker, or technology-validation study.',
  },
  {
    question: 'Can All-Voiced support clinical pre-post studies?',
    answer:
      'Potentially. All-Voiced can support structured perceptual evaluation of pre- and post-intervention voice samples where this is required by the study design. The workflow depends on the protocol, samples, blinding requirements, evaluator workflow, and agreed outputs.',
  },
  {
    question: 'What kinds of perceptual tasks can be configured?',
    answer:
      'Supported or configurable formats may include VAS ratings, paired comparisons or 2AFC, categorization, ranking, sorting, matching, CAPE-V-related workflows, and other study-specific tasks depending on methodological and technical feasibility.',
  },
  {
    question: 'Can studies include multiple evaluators or evaluator groups?',
    answer:
      'Potentially. Workflows may include individual evaluators, panels, groups, phases, sample allocations, or repeated evaluations where supported by the research design, access model, and agreed implementation.',
  },
  {
    question: 'Can workflows be blinded?',
    answer:
      'Blinding-related workflows may be supported through controlled labels, ordering, access, and presentation conditions. The required blinding model must be defined and verified with the research team.',
  },
  {
    question: 'Can All-Voiced support repeated or longitudinal evaluations?',
    answer:
      'Repeated phases or evaluation time points may be configured where supported by the agreed study workflow. The implementation scope should define how samples, time points, evaluators, and outputs are represented.',
  },
  {
    question: 'Can the infrastructure support multicenter studies?',
    answer:
      'Potentially. Multicenter work depends on governance, access models, evaluator coordination, language requirements, data handling, and institutional responsibilities. These conditions should be defined during study planning.',
  },
  {
    question: 'Does All-Voiced recruit research participants or evaluators?',
    answer:
      'Not by default. Recruitment of research participants normally remains with the responsible institution. Evaluator recruitment or panel coordination may be included only when explicitly agreed in the project scope.',
  },
  {
    question: 'Does All-Voiced train or calibrate study evaluators?',
    answer:
      'Training, calibration, familiarization, and evaluator qualification requirements vary by study. All-Voiced may support structured listening, practice, feedback, or calibration-related workflows where agreed, but participation does not automatically establish calibration or reliability. Any qualification threshold or calibration criterion must be defined by the study protocol.',
  },
  {
    question: 'What research outputs are available?',
    answer:
      'Core outputs may include raw response data, sample identifiers, structured ratings, completion records, and research exports. Aggregate or consensus values, variability summaries, reliability-related indicators, dashboards, reports, or evaluator metadata may be included where appropriate and explicitly agreed.',
  },
  {
    question: 'Can All-Voiced support custom dashboards or exports?',
    answer:
      'Potentially. Dashboards, reports, or study-specific exports may be included where supported by the existing infrastructure and explicitly defined in the agreed scope. Required outputs should be reviewed and verified before launch.',
  },
  {
    question: 'Is this the same as Perceptual Data Annotation?',
    answer:
      'No. Perceptual Research Infrastructure starts from a research protocol and a study-specific perceptual workflow. Perceptual Data Annotation starts from a dataset and the need to generate a structured human-perceptual layer. Some projects require both.',
  },
  {
    question: 'Does All-Voiced provide ethics approval or statistical analysis?',
    answer:
      'No, not by default. Ethics approval remains the responsibility of the relevant research institution. Statistical analysis, publication support, regulatory validation, legal responsibilities, and other research services are separate scope decisions.',
  },
  {
    question: 'How is pricing determined?',
    answer:
      'Pricing depends on workflow complexity, configuration, evaluator coordination, support, outputs, governance requirements, and any custom implementation needed.',
  },
  {
    question: 'What information should we prepare before discussing a study?',
    answer:
      'Helpful starting points include the research question, study design, sample types, expected number of samples and evaluators, blinding requirements, languages, timeline, governance constraints, desired outputs, and any existing protocol or ethics documentation.',
  },
];

export default function PerceptualResearchInfrastructureFAQ() {
  return (
    <section
      className="service-landing-section service-landing-faq"
      aria-labelledby="perceptual-research-infrastructure-faq-title"
    >
      <span className="services-label">
        FAQ
      </span>

      <h2 id="perceptual-research-infrastructure-faq-title">
        Perceptual Research Infrastructure FAQ
      </h2>

      <p>
        Common questions about designing and coordinating the perceptual
        layer of clinical and research studies.
      </p>

      <div className="service-landing-faq-list">
        {perceptualResearchInfrastructureFaqItems.map((item) => (
          <details className="service-landing-faq-item" key={item.question}>
            <summary>
              <span>{item.question}</span>
            </summary>

            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}